import { Container } from "@nodeme/grid-react";
import React from "react";
import "./assets/styles/App.css";
import { BrowserRouter as Router, Switch, Route } from "react-router-dom";

import Header from "./components/Header";
import Navigation from "./components/Navigation";
import Artworks from "./components/Artworks";

function App() {
  return (
    <div className="App">
      <Router>
        <Header>
          <Navigation />
        </Header>
        <main>
          <div style={{ backgroundColor: "#000", height: "150px" }} />
          <div style={{ marginTop: "-124px" }}>
            <Container notFluid>
              <Switch>
                <Route path="/" exact>
                  <Artworks />
                </Route>
              </Switch>
            </Container>
          </div>
        </main>
      </Router>
    </div>
  );
}

export default App;
